import { Card } from "antd";
import styled from "styled-components";

export const NewslistCard = styled(Card)`
  box-shadow: 1px 1px 8px 1px lightgrey;
  width: 100%;
  margin-top: 5px;
  margin-bottom: 10px;
  border-radius: 3px;
  border: 1px solid lightgrey;

  &:hover {
    cursor: grab;
  }
`;


export const StyledNewsCard = styled(Card)`
  width: 390px;
  /* margin-right: 10px; */

  .ant-card-body {  
    height: 200px;
  }

  @media (max-width: 1366px) {
    width: 300px !important;
    height: 190px !important;
  }
`;